import React from "react";
import { useEffect, useState } from "react";
import "./Breadcrumb.css";

const Breadcrumb = ({ user, onLogout }) => {
  const [displayName, setDisplayName] = useState(user);
  
  useEffect(() => {
  if (user) {
    setDisplayName(user);
  }
}, [user]);

  const handleLogout = () => {
    onLogout();
  };

  return (
    <div className="breadcrumb-header">
      <div className="breadcrumb-content">
        <span className="breadcrumb-icon">
          <img src="/img/common/user.svg" alt="" style={{width: '24px', height: '24px'}}/>
        </span>

        <span className="breadcrumb-username">
          {displayName || ""}
        </span>

        <span className="breadcrumb-separator">|</span>
        
        <span className="breadcrumb-logout" onClick={handleLogout}>
          ログアウト
        </span>
      </div>
    </div>
  );
};

export default Breadcrumb;
